document.addEventListener("DOMContentLoaded", function () {
  // Create container
  const heartContainer = document.createElement("div");
  heartContainer.className = "valentine-hearts";
  document.body.appendChild(heartContainer);

  const isMobile = window.innerWidth < 768;
  const heartCount = isMobile ? 18 : 35;
  const heartEmojis = ["❤", "💖", "💗", "💕"];

  for (let i = 0; i < heartCount; i++) {
    createHeart();
  }

  function createHeart() {
    const heart = document.createElement("div");
    heart.className = "heart";
    heart.innerHTML =
      heartEmojis[Math.floor(Math.random() * heartEmojis.length)];

    heart.style.left = Math.random() * 100 + "vw";
    heart.style.animationDuration = 6 + Math.random() * 6 + "s";
    heart.style.animationDelay = Math.random() * 5 + "s";
    heart.style.fontSize = 14 + Math.random() * 18 + "px";

    heartContainer.appendChild(heart);

    setTimeout(() => {
      heart.remove();
      createHeart();
    }, 12000);
  }
});
